import { defineLevel } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   MONDE 1 · NIVEAU 3 — LA CRÊTE, puis LE HÉRAUT.

     0:00  bloc C        18 s   pression verticale — densité maximale
     0:18  respiration    4 s
     0:22  bloc C2       18 s   pic : les deux natures de menace ensemble
     0:40  respiration    4 s
     0:44  bloc B2       16 s   reprise — quitter la crête en pleine action
     1:00  boss           —     le Héraut

   DERNIER niveau du monde 1 : c'est lui qui porte le boss. `levelSystem`
   bascule en « attente de mise à mort » au bloc `boss-heraut`, et abattre le
   Héraut termine le niveau — donc le monde. La couche application incrémente
   alors `worldsCleared` (jalon `monde-1-franchi`) et offre une carte.

   ⚠️ 1:00 et pas moins : la reprise b2-faucheur (16 s) démarre à 0:44 et se
   termine exactement à 1:00, quand le bloc de boss s'ouvre. Empiéter dessus
   supprimerait le CALME qui précède le boss — et ce silence n'est pas une
   transition, c'est ce qui fait exister le boss.
   ═══════════════════════════════════════════════════════════════════════════ */

export default defineLevel({
  id: 'monde-1-3',
  // 60 s de niveau + 96 s de marge pour le combat de boss.
  duration: 156,
  blocks: [
    { at: 0, wave: 'c1-pression' },
    { at: 18, wave: 'respiration' },
    { at: 22, wave: 'c2-crete' },
    { at: 40, wave: 'respiration' },
    { at: 44, wave: 'b2-faucheur' },
    { at: 60, wave: 'boss-heraut' },
  ],
});
